import axios from "axios";
import store from "@/store";
import router from '@/router';
import {isTokenValid} from '../helper/shared/JWTTokenHelper';
import MaintenanceMode from '../helper/shared/MaintenanceMode';
import {isNotNullOrUndefined} from '../helper/shared/TypeHelper';

const checkHealthClient = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    timeout: 30000,
    headers: { Accept: "application/json" }
});

const client = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    timeout: 30000,
    headers: { Accept: "application/json" }
});

const legacyClient = axios.create({
    baseURL: process.env.VUE_APP_LEGACY_API_URL,
    timeout: 30000
});

client.interceptors.request.use(async function (config) {
    let canContinue = await checkHealth();

    if (canContinue)
        return config;
    else
    {
        await store.dispatch('appNotAvailable');
        await router.push({name: 'app-not-available'}, function() {}, function() {});

        return Promise.reject({message: 'Anwendung steht aktuell nicht zur Verfügung'});
    }
});
client.interceptors.response.use(function (response){
        return response;
    },
    function (error){
        if (error.response)
        {
            if (error.response.status === 401)
            {
                store.dispatch('user/logout');
                store.dispatch('setLoginPreviousRoute', router.currentRoute.fullPath);
                router.push({name: 'login'});
            }
        }
        return Promise.reject(error);
    });

export function setApiToken(token)
{
    localStorage.setItem('jwt_token', token);
    client.defaults.headers.common["Authorization"] = "Bearer " + token;
}

export function removeApiToken()
{
    localStorage.removeItem('jwt_token');
}

// check localStorage for an old api token
// if a token is found check if it is still valid
export function checkApiToken() {
    let api_token = localStorage.getItem('jwt_token');

    if (api_token && isTokenValid(api_token))
    {
        setApiToken(api_token);

        return true;
    }
    else
        return false;
}

export async function request(args) {
    try
    {
        store.dispatch("alert/axiosBusy");
        const response = await client.request(args);
        store.dispatch("alert/axiosIdle");

        return response.data;
    }
    catch (error)
    {
        let message = {
            type: "error"
        };

        if (error.response)
        {
            message.message = resolveResponse(error.response);
            message.errors = error.response.data.errors;
        }
        else if (error.request)
            message.message = "Could not send request: " + JSON.stringify(error.request);
        else
            message.message = "Axios error: " + error.message;

        store.dispatch("alert/add", message);
        store.dispatch("alert/axiosIdle");
    }
}

export async function legacyRequest(args) {
    try
    {
        store.dispatch("alert/axiosBusy");

        if(args.method === 'get')
        {
            if(args.params === undefined)
            {
                args.params = {
                    access_key: process.env.VUE_APP_LEGACY_API_KEY
                };
            }
            else
            {
                let tempData = JSON.parse(JSON.stringify(args.params));

                args.params = {
                    access_key: process.env.VUE_APP_LEGACY_API_KEY,
                    data:       tempData
                }
            }
        }
        else
        {
            if(args.data === undefined)
            {
                args.data = {
                    access_key: process.env.VUE_APP_LEGACY_API_KEY
                };
            }
            else
            {
                let tempData = JSON.parse(JSON.stringify(args.data));

                args.data = {
                    access_key: process.env.VUE_APP_LEGACY_API_KEY,
                    data:       tempData
                }
            }
        }

        const response = await legacyClient.request(args);
        store.dispatch("alert/axiosIdle");

        return response.data;
    }
    catch (error)
    {
        let message = {
            type: "error"
        };

        if (error.response)
        {
            message.message = resolveResponse(error.response);
            message.errors = error.response.data.errors;
        }
        else if (error.request)
            message.message = "Could not send request: " + JSON.stringify(error.request);
        else
            message.message = "Unknown axios error: " + error.message;

        store.dispatch("alert/add", message);
        store.dispatch("alert/axiosIdle");
    }
}

function resolveResponse(response)
{
    if(response.status === 401)
        return 'Sie sind nicht authentifiziert/Ihre Sitzung ist abgelaufen. Bitte loggen Sie sich ein.';

    return "HTTP " + response.status + ": " + response.data.message
}

export function setDefaultHeader(headerName, headerValue)
{
    client.defaults.headers.common[headerName] = headerValue;
}

export async function checkHealth(checkQueryParamForSecret = false)
{
    let canContinue = true;
    try
    {
        let response = await checkHealthClient.request({
            url: '/api/check-health',
            method: 'get'
        });

        if (response && response.data.is_down)
        {
            store.dispatch('activateMaintenanceMode');

            let bypassSecretQueryParam = router.currentRoute.query.maintenanceSecret;

            if (checkQueryParamForSecret && isNotNullOrUndefined(bypassSecretQueryParam))
            {
                let bypassResponse = await checkHealthClient.request({
                    url: '/api/check-maintenance-bypass-secret',
                    method: 'post',
                    data: {
                        secret: bypassSecretQueryParam
                    }
                });

                if (bypassResponse && bypassResponse.data.bypass_token)
                    MaintenanceMode.setMaintenanceBypassToken(bypassResponse.data.bypass_token);
            }


            if (MaintenanceMode.checkMaintenanceBypassToken() === false)
                canContinue = false;
        }
    }
    catch (error)
    {
        canContinue = false;
    }

    return canContinue;
}
